// Play / Pause buttons for media (video, audio) on the viewer's current slide.
// The viewer is already on the same slide as the speaker (slide.changed sync),
// so the payload is empty: "play whatever media is on the current slide."

import { EventType } from '../../shared/protocol.js';

export default {
  id:   'media-controls',
  slot: 'media-controls',
  mount({ slot, iot }) {
    slot.innerHTML = `
      <button data-cmd="play" title="Play media on current slide">▶ Play</button>
      <button data-cmd="pause" title="Pause media on current slide">❚❚ Pause</button>
    `;
    slot.querySelector('[data-cmd="play"]').addEventListener('click',
      () => iot.publish(EventType.MEDIA_PLAY,  {}));
    slot.querySelector('[data-cmd="pause"]').addEventListener('click',
      () => iot.publish(EventType.MEDIA_PAUSE, {}));
  },
};
